import React from 'react';

import { formatTextWithLinks } from '../../utils/textFormatters';

import { YelpIcon } from './YelpIcon';

interface YelpMessageProps {
  text: string;
}

export const YelpMessage: React.FC<YelpMessageProps> = ({ text }) => (
  <div className="flex gap-2">
    <YelpIcon className="size-4 shrink-0" />
    <span>{formatTextWithLinks(text)}</span>
  </div>
);
